import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import * as productStore from '@src/stores/product';

const DEBOUNCE_MS = 300;

const getProductRepricingApi = () => productStore;

export function useTariffQuantityRepricing(widgetId: string, productId: string | undefined): void {
  const {
    loadRepricedSchedulings,
    productScheduleSelector,
    tariffsState,
    repricingAppliedHashSelector,
    pricingTariffGatedSelector,
    pricingTariffSelectionsHashSelector,
  } = getProductRepricingApi();
  const dispatch = useAppDispatch();
  const { selectedDate } = useAppSelector(tariffsState(widgetId, productId));
  const { dates } = useAppSelector(productScheduleSelector(productId ?? ''));
  const appliedHash = useAppSelector(repricingAppliedHashSelector(widgetId));
  const isSelectedDateLoaded = !!dates?.[selectedDate ?? ''];
  const gated = useAppSelector(pricingTariffGatedSelector(widgetId));
  const selections = useAppSelector(pricingTariffSelectionsHashSelector(widgetId));

  const timer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (!productId || !selectedDate || !isSelectedDateLoaded || !gated) return undefined;

    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      dispatch(loadRepricedSchedulings(widgetId, productId, selectedDate, selections));
    }, DEBOUNCE_MS);

    return () => clearTimeout(timer.current);
  }, [dispatch, widgetId, productId, selectedDate, selections, gated, isSelectedDateLoaded, appliedHash]);
}
